import React, { useState, useEffect } from "react";
import { useAuth } from "../authContext";
import axios from "axios";

const ProfilePage = () => {
  const { user } = useAuth();
  const [skills, setSkills] = useState([]);
  const [newSkill, setNewSkill] = useState({ skill: "", proficiency: 0, dateGained: "" });
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(true); // new loading state

  useEffect(() => {
    const fetchSkills = async () => {
      if (!user || !user.userId) return; // wait for user to be ready
      setLoading(true);
      try {
        const res = await axios.get(
          `https://internsightbackend.onrender.com/api/skills/?userId=${user.userId}`
        );
        setSkills(res.data || []);
      } catch (err) {
        console.error("Error fetching skills:", err);
        setError(err.response?.data?.message || "Error fetching skills.");
      } finally {
        setLoading(false);
      }
    };

    fetchSkills();
  }, [user]);

  if (!user || !user.userId) {
    return (
      <div style={{ textAlign: "center", padding: "2rem", fontSize: "1.2rem" }}>
        <h2>Please log in to access your profile.</h2>
      </div>
    );
  }

  const handleChange = (e) => {
    const { name, value } = e.target;
    setNewSkill({ ...newSkill, [name]: value });
  };

  const handleAddSkill = async (e) => {
    e.preventDefault();
    setError("");
    setMessage("");

    try {
      const res = await axios.post("https://internsightbackend.onrender.com/api/skills", {
        ...newSkill,
        userId: user.userId,
      });
      setSkills([...skills, res.data.skills[res.data.skills.length - 1]]);
      setMessage("Skill added successfully!");
      setNewSkill({ skill: "", proficiency: 0, dateGained: "" });
    } catch (err) {
      setError(err.response?.data?.message || "Error adding skill.");
    }
  };

  return (
    <div
      style={{
        maxWidth: "800px",
        margin: "3rem auto",
        padding: "2rem",
        borderRadius: "12px",
        boxShadow: "0 0 15px rgba(0,0,0,0.1)",
        background: "#f8f9fa",
      }}
    >
      <h2 style={{ textAlign: "center", marginBottom: "1.5rem", color: "#333" }}>
        Welcome, <span style={{ color: "#0077cc" }}>{user.username}</span>
      </h2>

      <form onSubmit={handleAddSkill} style={{ display: "grid", gap: "1rem", marginBottom: "2rem" }}>
        <input
          type="text"
          name="skill"
          placeholder="Skill Name"
          value={newSkill.skill}
          onChange={handleChange}
          required
          style={{ padding: "0.75rem", borderRadius: "8px", border: "1px solid #ccc" }}
        />
        <select
          name="proficiency"
          value={newSkill.proficiency}
          onChange={handleChange}
          required
          style={{ padding: "0.75rem", borderRadius: "8px", border: "1px solid #ccc" }}
        >
          <option value="0">Beginner</option>
          <option value="1">Intermediate</option>
          <option value="2">Expert</option>
        </select>
        <input
          type="date"
          name="dateGained"
          value={newSkill.dateGained}
          onChange={handleChange}
          style={{ padding: "0.75rem", borderRadius: "8px", border: "1px solid #ccc" }}
        />
        <button
          type="submit"
          style={{
            padding: "0.75rem",
            borderRadius: "8px",
            border: "none",
            backgroundColor: "#007bff",
            color: "#fff",
            fontWeight: "bold",
            cursor: "pointer",
          }}
        >
          ➕ Add Skill
        </button>
      </form>

      {message && <p style={{ color: "green", fontWeight: "500" }}>{message}</p>}
      {error && <p style={{ color: "red", fontWeight: "500" }}>{error}</p>}
      {loading ? (
        <p>Loading your skills...</p>
      ) : (
        <>
          <h3 style={{ marginTop: "2rem", marginBottom: "1rem", color: "#444" }}>Your Skills</h3>
          <div style={{ display: "grid", gap: "1rem" }}>
            {skills.length > 0 ? (
              skills.map((skill, index) => (
                <div
                  key={index}
                  style={{
                    padding: "1rem",
                    borderRadius: "10px",
                    background: "#fff",
                    boxShadow: "0 2px 5px rgba(0,0,0,0.08)",
                    textAlign: "left",
                  }}
                >
                  <strong style={{ fontSize: "1.1rem", color: "#0077cc" }}>{skill.skill}</strong>
                  <p style={{ margin: "0.3rem 0", color: "#555" }}>
                    Level: {["Beginner", "Intermediate", "Expert"][skill.proficiency]}
                  </p>
                  <p style={{ margin: 0, fontSize: "0.9rem", color: "#888" }}>
                    Gained on: {new Date(skill.dateGained).toLocaleDateString()}
                  </p>
                </div>
              ))
            ) : (
              <p style={{ color: "#666" }}>No skills added yet.</p>
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default ProfilePage;
